<template>
  <v-container class="page" :class="isLoggedIn && 'dashboard'">
    <h1 class="display-2 font-weight-light mt-5 mb-5">
      Under Maintenance
    </h1>
    <p class="font-weight-light mt-5 mb-5">
      {{ pageName }} is currently unter maintenance. Please check back in a few minutes!
    </p>
    <div v-if="debug">
      <p>Debug information:<br />{{ error }}</p>
    </div>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: ["error", "pageName"],
  computed: {
    ...mapGetters("auth", ["isLoggedIn"]),
    debug() {
      return document.domain.includes("localhost") || document.domain.includes("dev.");
    }
  }
};
</script>
